/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { ComplexDependencies } from './dependenciesComplexClass.generated';
import { fractionDependencies } from './dependenciesFraction.generated';
import { identityDependencies } from './dependenciesIdentity.generated';
import { matrixDependencies } from './dependenciesMatrix.generated';
import { multiplyDependencies } from './dependenciesMultiply.generated';
import { numberDependencies } from './dependenciesNumber.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { createPow } from '../../factoriesAny.js';
export var powDependencies = {
  ComplexDependencies: ComplexDependencies,
  fractionDependencies: fractionDependencies,
  identityDependencies: identityDependencies,
  matrixDependencies: matrixDependencies,
  multiplyDependencies: multiplyDependencies,
  numberDependencies: numberDependencies,
  typedDependencies: typedDependencies,
  createPow: createPow
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesPow.generated.js
// module id = 90
// module chunks = 0